export default __webpack_public_path__ + "static/media/img-10.f7961d6e.png";